import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { from, switchMap } from 'rxjs';
import { environment } from '../../environments/environment';
import { AuthService } from './auth.service';

const CSRF_TOKEN_KEY = 'tops.security.csrfToken';
const UNSAFE_METHODS = new Set(['POST', 'PUT', 'PATCH', 'DELETE']);

export const securityRequestInterceptor: HttpInterceptorFn = (request, next) => {
  const headers: Record<string, string> = {};
  if (UNSAFE_METHODS.has(request.method.toUpperCase())) {
    headers['X-CSRF-Token'] = csrfToken();
    headers['X-Request-Id'] = crypto.randomUUID();
  }

  if (!isProtectedBackendRequest(request.url)) {
    return next(Object.keys(headers).length ? request.clone({ setHeaders: headers }) : request);
  }

  const auth = inject(AuthService);
  return from(auth.accessToken()).pipe(
    switchMap((accessToken) => {
      if (accessToken) headers['Authorization'] = `Bearer ${accessToken}`;
      return next(request.clone({ setHeaders: headers }));
    }),
  );
};

function isProtectedBackendRequest(url: string): boolean {
  if (!url.startsWith(environment.backendApiBaseUrl)) return false;

  const path = url.slice(environment.backendApiBaseUrl.length);
  return !path.startsWith('/auth/');
}

function csrfToken(): string {
  const existingToken = sessionStorage.getItem(CSRF_TOKEN_KEY);
  if (existingToken) return existingToken;

  const token = crypto.randomUUID();
  sessionStorage.setItem(CSRF_TOKEN_KEY, token);
  return token;
}